$('#checkout-form').validate({
  ignore: '.ignore',
  rules: {
    email: {
      required: true,
      email: true
    },
    terms: true

  },
  messages: {
    email: {
      required: $('#checkout-form input[type=email]').data('msg'),
      email: $('#checkout-form input[type=email]').data('email')
    }
  },
  errorPlacement: function(error, element) {
    var placement = $(element).data('error');
    if (placement) {
      $(placement).append(error)
    } else {
      error.insertAfter(element);
    }
  }
});

$('input[name=shipping_to]').on('change', function(){
  var value = $('input[name=shipping_to]:checked').val();

  if (value == 1) {
    $('.to_address').slideDown('fast');
    $('.to_office').slideUp('fast');

    $('.to_address input').removeClass('ignore');
    $('.to_office input').addClass('ignore');
  }
  else if(value == 2){
    $('.to_address').slideUp('fast');
    $('.to_office').slideDown('fast');

    $('.to_address input').addClass('ignore');
    $('.to_office input').removeClass('ignore');
  }
});


if (checkIfExists('#checkout input[name=invoice]')) {
  $('#checkout input[name=invoice]').change(function () {
    if($('#checkout input[name=invoice]:checked').val() == 1) {
      $('.invoice-form-wrapper').slideDown('fast')
      $('.invoice-form-wrapper input').removeClass('ignore');
    }else{
      $('.invoice-form-wrapper').slideUp('fast')
      $('.invoice-form-wrapper input').addClass('ignore');
    }
  })
}

if (checkIfExists('#checkout input[name=payment]')) {
  $('input[name=payment]').on('change', function(){


    if($('#checkout input[name=payment]:checked').val() == 1) {
      $('label[for="payment_1"]').addClass('active');
      $('label[for="payment_2"]').removeClass('active');
    }else{
      $('label[for="payment_1"]').removeClass('active');
      $('label[for="payment_2"]').addClass('active');
    }

  })
}
